import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "server-platform" }
const _hoisted_3 = { class: "center" }
const _hoisted_4 = { class: "footer-info" }
const _hoisted_5 = { class: "center" }
const _hoisted_6 = { class: "link-box" }
const _hoisted_7 = { class: "link-title" }
const _hoisted_8 = { class: "link-list" }
const _hoisted_9 = { class: "co-link-wrap" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "title" }, "友情链接", -1)
const _hoisted_11 = { class: "logo" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "desc" }, "C2M柔性定制平台", -1)
const _hoisted_13 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("img", {
          src: _ctx.images.serverPlatform,
          alt: ""
        }, null, 8, ["src"])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.linkList, (links) => {
            return (_openBlock(), _createBlock("div", {
              class: "link-wrap",
              key: links.uid
            }, [
              _createVNode("div", _hoisted_7, [
                _createVNode("a", {
                  href: links.url ? links.url : 'javascript:;'
                }, _toDisplayString(links.title), 9, ["href"])
              ]),
              _createVNode("div", _hoisted_8, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(links.items, (linkItem) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "link-item",
                    key: linkItem.uid
                  }, [
                    _createVNode("a", {
                      href: linkItem.url ? linkItem.url : 'javascript:;'
                    }, _toDisplayString(linkItem.name), 9, ["href"])
                  ]))
                }), 128))
              ])
            ]))
          }), 128)),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("a", {
              href: _ctx.images.diviLogo.url,
              target: "_blank"
            }, [
              _createVNode("div", _hoisted_11, [
                _createVNode("img", {
                  src: _ctx.images.diviLogo.src,
                  alt: ""
                }, null, 8, ["src"])
              ])
            ], 8, ["href"]),
            _hoisted_12
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_13, _toDisplayString(_ctx.copyright), 1)
  ]))
}